// src/components/Header.js
import { Menu, Sun, Moon, LogOut } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const Header = ({ onToggleSidebar, onToggleDarkMode, isDarkMode }) => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();              // clear token and auth state
    navigate('/login');    // redirect to login page
  };

  return (
    <header className="flex items-center justify-between px-4 py-3 bg-white dark:bg-gray-900 shadow-md border-b border-gray-200 dark:border-gray-800">
      <div className="flex items-center gap-4">
        <button
          onClick={onToggleSidebar}
          className="text-gray-800 dark:text-white"
        >
          <Menu size={24} />
        </button>
        <h1 className="text-lg font-bold text-gray-900 dark:text-white">
          MVP 
        </h1>
      </div>

      <div className="flex items-center gap-4">
        <span className="text-sm font-normal text-gray-500 dark:text-gray-400">V.0.0.0</span>
        <button
          onClick={onToggleDarkMode}
          className="text-gray-800 dark:text-white"
        >
          {isDarkMode ? <Sun size={20} /> : <Moon size={20} />}
        </button>

        <button
          onClick={handleLogout}
          className="text-gray-800 dark:text-white hover:text-red-500"
          title="Logout"
        >
          <LogOut size={20} />
        </button>
      </div>
    </header>
  );
};

export default Header;
